import { Component } from '@angular/core';
import { ClaimTypeService, ClaimTypeUriBuilderParams } from '@app/core/services/claim-type.service';
import { ClaimType } from '../../../models/claim-type';
import { BaseSelectWithIdComponent } from '../base-select-with-id.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { OP, OpData } from '@app/core/services/base/base-service-with-bundle.service';
import * as _ from 'lodash-es';

@Component({
  selector: 'claim-type-select',
  templateUrl: '../base-select-with-id.component.html',
  styleUrls: ['../base-select-with-id.component.scss']
})
export class ClaimTypeSelectComponent extends BaseSelectWithIdComponent<ClaimType, ClaimTypeUriBuilderParams> {

  constructor(private claimTypeService: ClaimTypeService) {
    super(claimTypeService);
    this.defaultOptions = {
      label: marker('case.claim_type'),
      patchPath: 'claim_type',
      class: 'full-width',
      optional: true
    };
  }

  protected generateUriBuilderParams(): ClaimTypeUriBuilderParams {
    return new ClaimTypeUriBuilderParams();
  }

  public onSelectionChange(): void {
    const patches = new Array<OpData>();
    const selectedClaimType = _.find(this.list, (item: ClaimType) => item.id === this.selectedId);

    patches.push({
      op: OP.replace,
      path: `${this.mergedOptions.patchPath}_id`,
      value: selectedClaimType.id
    });

    patches.push({
      op: OP.replace,
      path: this.mergedOptions.patchPath,
      value: selectedClaimType.displayName
    });

    this.onMultiUpdate(patches);
  }
}
